// Central date formatters. All display of factura/subida/etc dates in the
// UI should go through these to keep the format consistent (per user's
// preference: MM/DD/YYYY).

/**
 * Formats an ISO date string (YYYY-MM-DD or full ISO datetime) as MM/DD/YYYY.
 * Returns "—" for null / undefined / unparseable inputs.
 */
export function formatDateShort(iso) {
  if (!iso) return "—";
  // Fast path for YYYY-MM-DD (avoids the timezone shift that Date() adds).
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso));
  if (m) return `${m[2]}/${m[3]}/${m[1]}`;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${mm}/${dd}/${d.getFullYear()}`;
}

/**
 * Formats an ISO datetime as MM/DD/YYYY HH:mm. Used for "created_at" /
 * "upload date" columns.
 */
export function formatDateTimeShort(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${mm}/${dd}/${d.getFullYear()} ${hh}:${mi}`;
}
